/* NM v71.57 — una sola autoridad para abrir/cerrar el menú móvil.
   No modifica producto, carrito, checkout ni cuenta. */
(function () {
  'use strict';

  function isMobile() {
    return !window.matchMedia || window.matchMedia('(max-width: 989px)').matches;
  }

  function focusWithoutScroll(element) {
    if (!element) return;
    try {
      element.focus({ preventScroll: true });
    } catch (error) {
      element.focus();
    }
  }

  function init() {
    var trigger = document.getElementById('MobileNavTrigger');
    var nav = document.getElementById('MobileNav');
    if (!trigger || !nav) return;

    var closeItem = nav.querySelector('.nm-mobile-nav-close-item');
    var closeButton = closeItem && closeItem.querySelector('.nm-mobile-nav-close');

    if (!closeItem) {
      closeItem = document.createElement('li');
      closeItem.className = 'nm-mobile-nav-close-item';
    }

    if (!closeButton) {
      closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'nm-mobile-nav-close';
      closeItem.appendChild(closeButton);
    }

    closeButton.setAttribute('aria-label', 'Cerrar menú');
    closeButton.innerHTML = '<span class="nm-mobile-nav-close__mark" aria-hidden="true">×</span><span>Cerrar</span>';
    nav.insertBefore(closeItem, nav.firstChild);

    var savedScrollY = 0;

    function menuIsOpen() {
      return nav.classList.contains('is-visible');
    }

    function lockPage() {
      savedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.documentElement.classList.add('nm-mobile-menu-open');
      document.body.classList.add('nm-mobile-menu-lock', 'nm-nav-open');
      document.body.style.setProperty('--nm-mobile-menu-lock-y', (-savedScrollY) + 'px');
    }

    function unlockPage() {
      var restoreY = savedScrollY;
      document.documentElement.classList.remove('nm-mobile-menu-open');
      document.body.classList.remove('nm-mobile-menu-lock', 'nm-nav-open');
      document.body.style.removeProperty('--nm-mobile-menu-lock-y');
      window.requestAnimationFrame(function () {
        window.scrollTo(0, restoreY);
      });
    }

    function openMenu() {
      lockPage();
      nav.classList.add('is-visible');
      nav.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      nav.scrollTop = 0;
      window.requestAnimationFrame(function () {
        nav.scrollTop = 0;
        focusWithoutScroll(closeButton);
      });
    }

    function closeMenu(returnFocus) {
      if (!menuIsOpen() && !document.body.classList.contains('nm-mobile-menu-lock')) return;
      nav.classList.remove('is-visible');
      nav.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      nav.scrollTop = 0;
      unlockPage();
      if (returnFocus) focusWithoutScroll(trigger);
    }

    function intercept(event, action) {
      event.preventDefault();
      event.stopImmediatePropagation();
      action();
    }

    /* Capture evita que el slideToggle heredado reabra el menú dentro de la página. */
    trigger.addEventListener('click', function (event) {
      if (!isMobile()) return;
      intercept(event, function () {
        if (menuIsOpen()) closeMenu(true);
        else openMenu();
      });
    }, true);

    closeButton.addEventListener('click', function (event) {
      intercept(event, function () { closeMenu(true); });
    }, true);

    nav.addEventListener('click', function (event) {
      if (event.target !== nav) return;
      intercept(event, function () { closeMenu(false); });
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !menuIsOpen()) return;
      event.stopImmediatePropagation();
      closeMenu(true);
    }, true);

    window.addEventListener('resize', function () {
      if (!isMobile()) closeMenu(false);
    }, { passive: true });

    window.addEventListener('pageshow', function () {
      if (menuIsOpen()) closeMenu(false);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
